module.exports = __webpack_public_path__ + "f17582d7c416c0645f05fef10ca4c356.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/quiz-icons/warmup.png
// module id = 3585
// module chunks = 0